(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-bbobbie"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bb-product-form')) {
    class BbProductForm extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.form = this.querySelector('form');
        const variantsEl = document.getElementById('ProductVariants-' + this.sectionId);
        this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

        this.querySelectorAll('.bb-pdp__opt-btn').forEach((btn) => {
          btn.addEventListener('click', () => this.handleOptionClick(btn));
        });

        this.qtyInput = this.querySelector('.bb-pdp__qty-input');
        const decreaseBtn = this.querySelector('[data-qty-decrease]');
        const increaseBtn = this.querySelector('[data-qty-increase]');
        if (decreaseBtn) decreaseBtn.addEventListener('click', () => this.stepQty(-1));
        if (increaseBtn) increaseBtn.addEventListener('click', () => this.stepQty(1));

        this.form.addEventListener('submit', (e) => this.handleSubmit(e));

        const stickyBtn = document.querySelector('[data-sticky-add-btn]');
        if (stickyBtn) {
          stickyBtn.addEventListener('click', () => {
            if (this.form.requestSubmit) this.form.requestSubmit();
            else this.form.dispatchEvent(new Event('submit', { cancelable: true }));
          });
        }
      }

      stepQty(delta) {
        const current = parseInt(this.qtyInput.value || '1', 10);
        this.qtyInput.value = Math.max(1, current + delta);
      }

      handleOptionClick(btn) {
        const group = btn.closest('.bb-pdp__buttons');
        group.querySelectorAll('.bb-pdp__opt-btn').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.updateVariant();
      }

      getSelectedOptions() {
        const options = [];
        this.querySelectorAll('.bb-pdp__option').forEach((optionEl) => {
          const selected = optionEl.querySelector('.bb-pdp__opt-btn.is-selected');
          options.push(selected ? selected.dataset.value : null);
        });
        return options;
      }

      updateVariant() {
        const selected = this.getSelectedOptions();
        const match = this.variants.find((v) =>
          selected.every((val, i) => val === null || v.options[i] === val)
        );
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        const priceEl = document.getElementById('ProductPrice-' + this.sectionId);
        const lowStockEl = document.querySelector('[data-low-stock]');
        const stickyPriceEl = document.querySelector('[data-sticky-price]');
        if (!match || !addBtn) return;

        document.getElementById('ProductSelectedVariant-' + this.sectionId).value = match.id;

        if (priceEl) {
          const current = priceEl.querySelector('.bb-pdp__price-current');
          const compare = priceEl.querySelector('.bb-pdp__price-compare');
          const label = priceEl.querySelector('[data-price-label]');
          if (current) current.textContent = this.formatMoney(match.price);
          if (match.compare_at_price && match.compare_at_price > match.price) {
            if (compare) { compare.textContent = this.formatMoney(match.compare_at_price); compare.style.display = ''; }
            if (label) label.textContent = addBtn.dataset.saleLabel || 'Precio rebajado';
          } else {
            if (compare) compare.style.display = 'none';
            if (label) label.textContent = addBtn.dataset.regularLabel || 'Precio';
          }
        }
        if (stickyPriceEl) stickyPriceEl.textContent = this.formatMoney(match.price);

        if (lowStockEl) {
          const isLow = match.inventory_management === 'shopify' && match.inventory_quantity > 0 && match.inventory_quantity <= (parseInt(lowStockEl.dataset.threshold || '5', 10));
          lowStockEl.classList.toggle('is-hidden', !isLow);
        }

        const label = addBtn.querySelector('[data-add-btn-text]');
        const stickyLabel = document.querySelector('[data-sticky-btn-text]');
        if (match.available) {
          addBtn.disabled = false;
          if (label) label.textContent = addBtn.dataset.addText || 'Añadir al carrito';
          if (stickyLabel) stickyLabel.textContent = addBtn.dataset.addText || 'Añadir al carrito';
        } else {
          addBtn.disabled = true;
          if (label) label.textContent = addBtn.dataset.soldText || 'Agotado';
          if (stickyLabel) stickyLabel.textContent = addBtn.dataset.soldText || 'Agotado';
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      formatMoney(cents) {
        try {
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
          return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'CLP' ? 0 : 2,
          }).format(cents / 100);
        } catch (e) {
          return '$' + (cents / 100).toFixed(2);
        }
      }

      handleSubmit(e) {
        e.preventDefault();
        const addBtn = document.getElementById('AddToCart-' + this.sectionId);
        if (!addBtn || addBtn.disabled) return;
        addBtn.classList.add('is-loading');
        const formData = new FormData(this.form);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((r) => {
            if (!r.ok) throw new Error('add-to-cart-failed');
            return r.json();
          })
          .then(() => {
            addBtn.classList.remove('is-loading');
            addBtn.classList.add('is-added');
            const label = addBtn.querySelector('[data-add-btn-text]');
            if (label) label.textContent = 'Agregado ✓';
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              addBtn.classList.remove('is-added');
              this.updateVariant();
            }, 2000);
          })
          .catch(() => {
            addBtn.classList.remove('is-loading');
            this.form.submit();
          });
      }
    }
    customElements.define('bb-product-form', BbProductForm);
  }

  (function () {
    document.querySelectorAll('.bb-pdp__image').forEach((img) => {
      img.addEventListener('click', () => img.classList.toggle('is-zoomed'));
    });

    document.querySelectorAll('.bb-pdp__gallery').forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('.bb-pdp__media'));
      const dotsContainer = gallery.parentElement.querySelector('[data-gallery-dots]');
      if (!dotsContainer || slides.length < 2) return;

      dotsContainer.classList.add('has-dots');
      slides.forEach((slide, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bb-pdp__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1));
        dot.addEventListener('click', () => {
          slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
        dotsContainer.appendChild(dot);
      });

      const dots = Array.from(dotsContainer.children);
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const idx = slides.indexOf(entry.target);
              if (idx > -1) {
                dots.forEach((d) => d.classList.remove('is-active'));
                dots[idx].classList.add('is-active');
              }
            }
          });
        },
        { root: gallery, threshold: 0.6 }
      );
      slides.forEach((slide) => observer.observe(slide));
    });

    document.querySelectorAll('[data-open-size-guide]').forEach((btn) => {
      const section = btn.closest('.bb-pdp');
      const modal = section ? section.querySelector('[data-size-guide-modal]') : null;
      if (!modal) return;
      btn.addEventListener('click', () => {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    document.querySelectorAll('[data-close-size-guide]').forEach((el) => {
      el.addEventListener('click', () => {
        const modal = el.closest('[data-size-guide-modal]');
        if (modal) modal.hidden = true;
        document.body.style.overflow = '';
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-size-guide-modal]:not([hidden])').forEach((modal) => {
          modal.hidden = true;
          document.body.style.overflow = '';
        });
      }
    });

    document.querySelectorAll('[data-sticky-bar]').forEach((bar) => {
      const section = bar.closest('.bb-pdp');
      const mainBtn = section ? section.querySelector('.bb-pdp__add-btn') : null;
      if (!mainBtn) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            bar.hidden = entry.isIntersecting;
          });
        },
        { threshold: 0 }
      );
      observer.observe(mainBtn);
    });

    document.querySelectorAll('.bb-pdp__related').forEach((container) => {
      const grid = container.querySelector('.bb-pdp__related-grid');
      const productId = container.dataset.productId;
      const limit = container.dataset.limit || 8;
      if (!grid || !productId) return;

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=related')
        .then((r) => r.json())
        .then((data) => {
          if (!data.products || !data.products.length) {
            container.style.display = 'none';
            return;
          }
          const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
          const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: currency === 'CLP' ? 0 : 2,
          });
          grid.innerHTML = data.products
            .map((p) => {
              const img = p.featured_image || (p.images && p.images[0]) || '';
              return (
                '<a href="' + p.url + '" class="bb-pdp__related-card">' +
                '<div class="bb-pdp__related-image"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
                '<p class="bb-pdp__related-title">' + p.title + '</p>' +
                '<p class="bb-pdp__related-price">' + formatter.format(p.price / 100) + '</p>' +
                '</a>'
              );
            })
            .join('');
        })
        .catch(() => {
          container.style.display = 'none';
        });
    });

    document.querySelectorAll('.bb-pdp__recent').forEach((container) => {
      const grid = container.querySelector('.bb-pdp__recent-grid');
      const currentHandle = container.dataset.currentHandle;
      const limit = parseInt(grid ? grid.dataset.limit : '4', 10) || 4;
      if (!grid || !currentHandle) return;

      let viewed = [];
      try {
        viewed = JSON.parse(localStorage.getItem('bb_recently_viewed') || '[]');
      } catch (e) {
        viewed = [];
      }

      const toShow = viewed.filter((h) => h !== currentHandle).slice(0, limit);

      viewed = [currentHandle].concat(viewed.filter((h) => h !== currentHandle)).slice(0, 12);
      try {
        localStorage.setItem('bb_recently_viewed', JSON.stringify(viewed));
      } catch (e) {}

      if (!toShow.length) return;

      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CLP';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: currency === 'CLP' ? 0 : 2,
      });

      Promise.all(
        toShow.map((handle) =>
          fetch('/products/' + handle + '.js')
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      ).then((products) => {
        const valid = products.filter(Boolean);
        if (!valid.length) return;
        grid.innerHTML = valid
          .map((p) => {
            const img = p.featured_image || (p.images && p.images[0]) || '';
            return (
              '<a href="' + p.url + '" class="bb-pdp__recent-card">' +
              '<div class="bb-pdp__recent-image"><img src="' + img + '" alt="' + p.title + '" loading="lazy"></div>' +
              '<p class="bb-pdp__recent-title">' + p.title + '</p>' +
              '<p class="bb-pdp__recent-price">' + formatter.format(p.price / 100) + '</p>' +
              '</a>'
            );
          })
          .join('');
        container.hidden = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
